import { captureException } from '@sentry/browser';

// eslint-disable-next-line import/prefer-default-export
export function base64ToBlob(data, contentType = '', sliceSize = 512) {
  let byteCharacters = null;
  try {
    byteCharacters = window.atob(data);
  } catch (err) {
    if (process.env.NODE_ENV === 'production') {
      captureException(err, {
        extra: {
          imageData: data,
        },
      });
    }
  }
  if (!byteCharacters) return null;

  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}



// WEBPACK FOOTER //
// ./src/lib/form.js